import { GrowColumn } from "pages/styles";
import { Panel } from "components/Panel/Panel";
import { SingleColumnPage } from "pages/PageTemplates";
import { useMultiRegionFilter } from "model/Filter/CommunityFilters";
import { FilterContainer } from "components/Filters/styles";
import { MultiToggleFilter } from "components/Filters/MultiToggleFilter/MultiToggleFilter";
import { FilterRow } from "components/FilterPanels/styles";
import { RootState } from "app/store";
import { useAppSelector } from "app/hooks";
import { useEffect, useState } from "react";
import {
  isCommunitySnapshotSetup,
  setupCommunitySnapshot,
} from "db/info/communityInfo";
import { CommunityGrid } from "components/Community/CommunityGrid/CommunityGrid";
import { isRegion, Region, REGION_GLOBAL } from "model/Region";
import { Community } from "model/Community/Community";
import { anyStringContains } from "Utility";
import { SearchBar } from "./styles";
import { MessageBox } from "styles/text";

const selectCommunitiesLoaded = (state: RootState) =>
  state.community.intialLoadComplete;

const selectCommunities = (state: RootState, regions: Region[]) =>
  state.community.data;

const byRegions = (community: Community, regions: Region[]) => {
  if (!community.region || !isRegion(community.region)) {
    return regions.includes(REGION_GLOBAL);
  }

  return regions.includes(community.region);
};

const bySearchText = (community: Community, search: string) =>
  anyStringContains(
    search,
    community.description,
    community.name,
    community.region,
    ...(community.tags ?? [])
  );

export const CommunityPage = () => {
  useEffect(() => {
    if (!isCommunitySnapshotSetup()) {
      setupCommunitySnapshot();
    }
  }, []);

  const regionFilter = useMultiRegionFilter();
  const [searchText, setSearchText] = useState("");

  const communitiesLoaded = useAppSelector(selectCommunitiesLoaded);
  const communities = useAppSelector((state) =>
    selectCommunities(state, regionFilter.selectedValues)
  );

  const filteredCommunities = communities.filter(
    (c) =>
      byRegions(c, regionFilter.selectedValues) && bySearchText(c, searchText)
  );
  return (
    <SingleColumnPage>
      <GrowColumn>
        <Panel>
          <MessageBox style={{ textAlign: "center" }}>
            If you notice a broken link, incorrect tag, or you're looking for a
            community that's not listed, feel free to contact us and let us
            know! We’ll do our best to keep this list accurate and up to date.
          </MessageBox>
        </Panel>
        <Panel padding="padded" loading={!communitiesLoaded}>
          <FilterContainer>
            <FilterRow>
              <MultiToggleFilter filter={regionFilter} header="Regions" />
            </FilterRow>
          </FilterContainer>
          <SearchBar
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search by name, description or tags"
          />
        </Panel>
        {communitiesLoaded && (
          <CommunityGrid communities={filteredCommunities} />
        )}
      </GrowColumn>
    </SingleColumnPage>
  );
};
